"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var parseQuery = function parseQuery(query) {
  if (!query || typeof query !== 'string') {
    return {};
  }
  return Object.fromEntries(decodeURIComponent(query).split('&').map(function (v) {
    return v.split('=');
  }));
};
var _default = exports["default"] = parseQuery;
//# sourceMappingURL=parseQuery.js.map